import { render, staticRenderFns } from "./ProductSelectCountdownHeader.vue?vue&type=template&id=736a035f&scoped=true"
import script from "./ProductSelectCountdownHeader.vue?vue&type=script&lang=js"
export * from "./ProductSelectCountdownHeader.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectCountdownHeader.vue?vue&type=style&index=0&id=736a035f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a035f",
  null
  
)

export default component.exports